import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { transportAPI } from '../../services/api';
import { getErrorMessage } from '../../utils/errorHandler';

export const fetchRoutes = createAsyncThunk('transport/routes', async (params, { rejectWithValue }) => {
  try {
    const response = await transportAPI.fetchRoutes(params);
    return response.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to fetch routes'));
  }
});

export const createRoute = createAsyncThunk('transport/createRoute', async (data, { rejectWithValue }) => {
  try {
    const response = await transportAPI.createRoute(data);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to create route'));
  }
});

export const fetchStops = createAsyncThunk('transport/stops', async (params, { rejectWithValue }) => {
  try {
    const response = await transportAPI.fetchStops(params);
    return response.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to fetch stops'));
  }
});

export const createStop = createAsyncThunk('transport/createStop', async (data, { rejectWithValue }) => {
  try {
    const response = await transportAPI.createStop(data);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to create stop'));
  }
});

export const assignStudent = createAsyncThunk('transport/assignStudent', async (data, { rejectWithValue }) => {
  try {
    const response = await transportAPI.assignStudent(data);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(getErrorMessage(error, 'Failed to assign student'));
  }
});

const initialState = {
  routes: [],
  stops: [],
  assignments: [],
  stats: null,
  loading: false,
  error: null,
};

const transportSlice = createSlice({
  name: 'transport',
  initialState,
  reducers: {
    clearTransportError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoutes.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchRoutes.fulfilled, (state, action) => { state.loading = false; state.routes = action.payload.data || action.payload; })
      .addCase(fetchRoutes.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(createRoute.fulfilled, (state, action) => { state.routes.unshift(action.payload); })
      .addCase(fetchStops.fulfilled, (state, action) => { state.stops = action.payload.data || action.payload; })
      .addCase(createStop.fulfilled, (state, action) => { state.stops.unshift(action.payload); })
      .addCase(assignStudent.fulfilled, (state, action) => { state.assignments.unshift(action.payload); });
  },
});

export const { clearTransportError } = transportSlice.actions;
export default transportSlice.reducer;
